import { ContentPublicationListResponse, ContentSeriesResponse, } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, contentQs, contentRequest } from '../api.js';
/** GET /stats/series — ряды графиков по дате публикации. */
export function getStatsSeries(p) {
    return contentRequest(ContentSeriesResponse, `${BASE}/stats/series${contentQs({
        account: p.account,
        bucket: p.bucket,
        ...('period' in p.range
            ? { period: p.range.period }
            : { from: p.range.from, to: p.range.to }),
    })}`);
}
/** Сколько самых просматриваемых роликов периода берёт «Топ клипов». */
export const TOP_PUBLICATIONS_LIMIT = 200;
/**
 * GET /publications — первые {@link TOP_PUBLICATIONS_LIMIT} роликов периода
 * по просмотрам (постраничный режим, `total` — всего роликов в периоде).
 */
export function listTopPublications(p) {
    return contentRequest(ContentPublicationListResponse, `${BASE}/publications${contentQs({
        account: p.account,
        ...('period' in p.range
            ? { period: p.range.period }
            : { from: p.range.from, to: p.range.to }),
        sort: 'views',
        dir: 'desc',
        page: '1',
        pageSize: String(TOP_PUBLICATIONS_LIMIT),
    })}`);
}
//# sourceMappingURL=overview.js.map